import React, { useCallback } from "react";

import { DeviceTesterTestState } from "../../../types/Device.types";
import {
  useDeviceTesterDispatchContext,
  useDeviceTesterStateContext,
} from "../../device-tester-context-provider/DeviceTesterContextProvider";
import { usePlatformTypeContext } from "../../platform-type-provider/PlatformTypeProvider";
import { DeviceTesterActionType } from "../../device-tester-context-provider/Reducer.types";

import { logFinishedSessionBeforeAudioTest } from "./ConnectedResultsFinishTestButton.telemetry";
import { ResultsTestFinishedButton } from "./ResultsFinishTestButton";

export const ConnectedResultsFinishTestButton: React.FC = () => {
  const { isMobile } = usePlatformTypeContext();
  const { deviceTesterDispatch } = useDeviceTesterDispatchContext();
  const { deviceTesterState } = useDeviceTesterStateContext();

  const completeTest = useCallback(async () => {
    logFinishedSessionBeforeAudioTest();
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_DEVICE_TEST_STATE,
      state: DeviceTesterTestState.COMPLETE,
    });
  }, [deviceTesterDispatch]);

  return (
    <ResultsTestFinishedButton
      completeTest={completeTest}
      isInfoFetched={deviceTesterState.isInfoFetched}
      isMobile={isMobile}
    />
  );
};
